'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var AFFILIATE_QUERY = 'affiliate:query';
var UTM_PARAMS = 'utm-params';

exports.AFFILIATE_QUERY = AFFILIATE_QUERY;
exports.UTM_PARAMS = UTM_PARAMS;
